import SkipAutoReplenModal from 'components/GlobalModals/SkipAutoReplenModal/SkipAutoReplenModal';
import { withSkipAutoReplenModalProps } from 'viewModel/globalModals/skipAutoReplenModal/withSkipAutoReplenModalProps';

const ConnectedSkipAutoReplenModal = withSkipAutoReplenModalProps(SkipAutoReplenModal);

export default ConnectedSkipAutoReplenModal;
